/**
 * Created by Xuz on 2021/09/15.
 * xuz[at]live[dot]cn
 *
 * 流程跟踪
 */
import * as WFC from './WFConstants'
import WFHelper from '@/views/workflow/design/editor/js/WFHelper'

class WFTracker {
  constructor (workflow) {
    this.workflow = workflow
    this.oSvgJs = this.workflow.getSvgJs()
    this.history = this.workflow.parent.getHistory()
    this.trackedList = []
    this.nodeUsers = []
    this.lastTrackLink = null
  }

  onLoad () {
    // let path = this.oSvgJs.path()
    // path.attr('stroke', 'red')
    // path.attr('fill', 'red')
    // path.attr('d', 'M 0 0 L 10 5 L 0 10 z')

    // var marker = path.marker('end', 5, 0)

    let marker = this.oSvgJs.defs().marker(20, 6)
    marker.attr('markerUnits', 'strokeWidth')
    marker.attr('refY', 5)
    marker.attr('refX', 0)
    marker.attr('viewBox', '0 0 10 10')
    marker.attr('id', 'redArrow')
    marker.attr('preserveAspectRatio', 'xMidYMid meet')
    marker.attr('orient', 'auto')
    marker.path('M 0 0 L 10 5 L 0 10 z').attr({
      'stroke': 'red',
      'fill': 'red'
    })

    // console.log('tracker history: ')
    // console.log(this.history)

    let pathMotion = []

    let wfLinkId = null
    let wfLink = null
    let lastWFLinkId = null
    let svgD = null
    this.history.forEach(nodeLink => {
      wfLinkId = nodeLink.pass_route
      wfLink = this.workflow.getElement(wfLinkId)

      if (wfLink == null) {
        return
      }

      // 如果路径是同一路径的就不再做动画
      if (lastWFLinkId === wfLinkId) {
        return
      }

      svgD = wfLink.getLine().attr('d')
      pathMotion.push(svgD)
      wfLink.onTrackStyle()

      lastWFLinkId = wfLinkId
    })

    this.doPushWFRunnerX()

    this.dGImg = this.oSvgJs.group()
    const trans2 = 'translate(' + 0 + ', ' + 0 + ')'
    this.dGImg.attr('transform', trans2)

    let dImg = this.oSvgJs.image('app/workflow/img/design/go.png').size(16, 16)
    this.dGImg.add(dImg)

    const aniPath = this.oSvgJs.path(pathMotion.join(' '))
    aniPath.attr('fill', 'none')
    const aniPathLen = aniPath.length()
    let duration = 1100 * pathMotion.length
    dImg.animate(duration).ease('<>').during(function (pos) {
      let p = aniPath.pointAt(pos * aniPathLen)
      dImg.center(p.x, p.y)
    }).loop(true)
  }

  locate (from, to) {
    console.log('locate: ' + from + ', ' + to)
    let start = null
    let end = null
    if (from) {
      start = this.workflow.getElement(from)
    } else {
      start = this.workflow.getStartNode()
    }
    end = this.workflow.getElement(to)
    this.clearLocate()
    let link = this.workflow.getRoad(start.uuid(), end.uuid())
    if (link == null) {
      this.clearLocate()
      return
    }
    link.onSelect()
    this.lastTrackLink = link
  }

  clearLocate () {
    if (this.lastTrackLink == null) {
      return
    }
    this.lastTrackLink.onUnSelect()
    this.lastTrackLink = null
  }

  doPushWFRunnerX () {
    let wfLinkId = null
    let wfLink = null
    this.history.forEach(nodeLink => {
      wfLinkId = nodeLink.pass_route

      if (this.trackedList[wfLinkId] == null) {
        wfLink = this.workflow.getElement(wfLinkId)
        if (wfLink == null) {
          return
        }

        wfLink.onTrackStyle()
        this.trackedList[wfLinkId] = ''
      }

      const actId = nodeLink.act_id
      if (this.nodeUsers[actId] == null) {
        this.nodeUsers[actId] = []
      }
      let u = []
      u.id = nodeLink.handler_id
      u.name = nodeLink.handler
      u.signed = !!nodeLink.sign_date
      u.flowType = nodeLink.flow_type
      this.nodeUsers[actId].push(u)
    })

    // console.log(this.nodeUsers)

    // 画节点
    for (let actId in this.nodeUsers) {
      const actUsers = this.nodeUsers[actId]
      this.createNodeHandler(actId, actUsers)
    }
  }

  createNodeHandler (actId, actUsers) {
    let el = this.workflow.getElement(actId)
    // 只有一般节点才画图
    if (el.getType() !== WFC.NODE_TYPE_COMMON_NODE) {
      return
    }
    // 指定节点的座标
    const elPos = this.getElPos(el)
    const elRect = WFHelper.getRect(el.getSvg())
    const id = 'HD' + actId
    let g = this.oSvgJs.group()
    let trans = 'translate(' + (elPos.x * 1 + elRect.width - elRect.width / 2 + 20) + ',' + (elPos.y * 1 - 5) + ')'
    g.attr('transform', trans)
    g.attr('id', id)
    let polygon = g.polygon()
    polygon.attr('stroke', '#000000')
    polygon.attr('stroke-width', '1')
    polygon.attr('fill', '#ffcc00')
    polygon.attr('points', '0,0')
    polygon.attr('shape-rendering', 'optimizeSpeed')

    let j = 0
    let content = []
    let pushed = []
    let cursor = false
    actUsers.forEach(user => {
      if (pushed[user.id] != null) {
        return
      }
      if (j === 2) {
        cursor = true
        content.push('(共')
        content.push(this.calcTaskUserCount(actUsers))
        content.push('人)')
        return
      }
      if (j !== 0) {
        content.push(',')
      }
      content.push(user.name)
      pushed[user.id] = ''
      j++
    })

    let text = g.text(function (add) {
      add.tspan(content.join('')).dx(5).dy(12)
    })
    let textRect = WFHelper.getRect(text)
    let iWidth = textRect.width + 8
    polygon.attr('points', '0,-2 ' + iWidth + ',-2 ' + iWidth + ',16 6,16 -4,20 0,12 0,0')

    if (cursor) {
      text.attr('style', 'cursor:pointer')
      g.click(() => {
        this.showMoreNodeUsers(actId)
      })
    }
  }

  getElPos (el) {
    let transform = el.getSvg().attr('transform')
    let pos = []
    let idx = transform.indexOf('(') + 1
    let idxEnd = transform.indexOf(')')
    transform = transform.substring(idx, idxEnd)
    transform = transform.split(',')
    pos.x = transform[0]
    pos.y = transform[1]

    return pos
  }

  calcTaskUserCount (users) {
    let f = []
    let j = 0
    for (let i = 0; i < users.length; i++) {
      let m = users[i]
      if (f[m.id] == null) {
        j++
        f[m.id] = ''
      }
    }
    return j
  }

  showMoreNodeUsers (actId) {
    let users = this.nodeUsers[actId]
    let s = []
    let f = []
    for (let i = 0; i < users.length; i++) {
      let user = users[i]
      if (f[user.id] == null) {
        s.push(user.name)
        f[user.id] = ''
      }
    }
    this.workflow.parent.$info({
      title: '该点办理用户[' + s.length + ']人，列表如下：',
      content: s.join(',')
    })
    // ()
  }
}

export default WFTracker
